<template>
  <div class="resolve">
    <h1>JLINC DID Resolver</h1>
    <form @submit.prevent="getResolved">
      <input type="text" name="did" v-model="resolved" @keyup="validateDID" placeholder="Enter DID">
      <div class="Loading" v-show="loading"><p class="spinner"></p></div>
      <p class="error">{{err}}&nbsp;</p>
      <button v-show="reset" type="button" @click="resetResolve" class="Button-success Button-thin">Reset</button>
      <button v-show="!reset" type="submit" class="Button-primary Button-thin" :disabled="submitDisabled">Resolve</button>
    </form>

    <div v-show="reset" class="didstring">
      <pre v-html="didstring"></pre>
    </div>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "ResolveDID",
  data() {
    return {
      reset: false,
      loading: false,
      resolved: '',
      submitDisabled: true,
      didstring: '',
      err: ''
    }
  },
  methods: {
    getResolved: function() {
      this.err = '';
      this.loading = true;
      let url = 'https://testnet.did.jlinc.org/' + this.resolved;
      axios.get(url)
      .then(response => {
        this.reset = true;
        this.loading = false;
        this.didstring = JSON.stringify(response.data.did, null, 2);
      })
      .catch(e => {
        this.loading = false;
        if (e.response.status === 404) {
          this.err = 'Not Found'
        } else if (e.response.status === 410) {
          this.err = 'Revoked'
        } else {
          this.err = e.message
        }
      });

    },
    validateDID: function() {
      this.submitDisabled = !/^did:jlinc:[\w-]+$/.test(this.resolved);
    },
    resetResolve: function() {
      this.resolved = '';
      this.didstring = '';
      this.reset = false;
      this.submitDisabled = true;
      this.err = '';
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1 {
  font-size: 18px;
  margin: 40px 0 30px;
}
label {
  font-size: 0.85em;
  span {
    text-align: center;
  }
}
input {
  margin: 0 auto 5px;
  padding: 5px 7px;
  display: block;
  width: 350px;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  &.spacer {
    margin-bottom: 30px;
  }
}
::placeholder {
  font-size: 1.2em;
  color: #ccc;
  text-align: center;
}
.didstring {
  text-align: left;
  margin: 30px auto;
  padding: 5px;
  width: 650px;
  color: #000;
  background: #f9f9f9;
  border: 1px solid #ccc;
  overflow: scroll;
}
.error {
  margin: 8px 0 12px;
  color: #f30;
}
.Loading {
  height: 25px;
  width: 25px;
  margin: 5px auto -30px;
  .spinner {
    display: block;
    height: 25px;
    width: 25px;
    background-image: url(../assets/knot.svg);
    background-position: center;
    background-size: cover;
    -webkit-animation: Loading-spin 2s infinite linear;
    animation: Loading-spin 2s infinite linear;
  }
  @keyframes Loading-spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
}
</style>
